import Swiper from 'swiper';

export default class RecentWorkImageSlider {
    constructor($el) {
        this.$el = $el;

        this.initSlider = this.initSlider.bind(this);

        this.initSlider();
    }

    initSlider() {
        new Swiper(this.$el, {
            spaceBetween: 20,
            loop: true,
            slidesPerView: 2.5,
            autoplay: {delay: 4000,},
            infinite: true,
            breakpoints: {
                992: {
                    slidesPerView: 3.5,
                },
                1320: {
                    slidesPerView: 4.5,
                }
            }
        });
    }
}